import layoutHeaderAside from '@/layout/header-aside'
const files = require.context('./', true, /\.js$/)

let componentMaps = {
  'layoutHeaderAside': layoutHeaderAside,
  'serviceManager': () => import(/* webpackChunkName: "serviceManager" */'@/pages/auth/service/index'),
  'userManager': () => import(/* webpackChunkName: "userManager" */'@/pages/admin/user'),
  'groupManager': () => import(/* webpackChunkName: "groupManager" */'@/pages/admin/group'),
  'menuManager': () => import(/* webpackChunkName: "menuManager" */'@/pages/admin/menu'),
  'gateLogManager': () => import(/* webpackChunkName: "gateLogManager" */'@/pages/admin/gateLog'),
  'groupTypeManager': () => import(/* webpackChunkName: "groupTypeManager" */'@/pages/admin/groupType'),
  'devFormManager': () => import(/* webpackChunkName: "devFormManager" */'@/pages/dev/build'),
  'codeManager': () => import(/* webpackChunkName: "codeManager" */'@/pages/dev/code'),
  'onlineManager': () => import(/* webpackChunkName: "onlineManager" */'@/pages/admin/online'),
  'ElementExtractRuleManager': () => import(/* webpackChunkName: "ElementExtractRuleManager" */'@/pages/sysTool/regex'),
  'ElementTypeManager': () => import(/* webpackChunkName: "ElementExtractRuleManager" */'@/pages/sysTool/elementType'),
  'UploadManager': () => import(/* webpackChunkName: "UploadManager" */'@/pages/sysTool/upload'),
  'CaseRecordManager': () => import(/* webpackChunkName: "CaseRecordManager" */'@/pages/caseMediate/caseRecord'),
  'FileTemplate': () => import(/* webpackChunkName: "FileTemplate" */'@/pages/caseMediate/fileTemplate'),
  'CzCaseManager': () => import(/* webpackChunkName: "CzCaseManager" */'@/pages/caseMediate/czCaseInfo'),
  'CzAgentManager': () => import(/* webpackChunkName: "CzCaseManager" */'@/pages/caseMediate/czAgent'),
  'CzBankManager': () => import(/* webpackChunkName: "CzBankManager" */'@/pages/caseMediate/czBankInfo'),
  'CommonConfig': () => import(/* webpackChunkName: "CommonConfig" */'@/pages/caseMediate/commonConfig'),
  'LiuzhuanManager': () => import(/* webpackChunkName: "LiuZhuan" */'@/pages/sysTool/liuzhuan'),
  'CzMessageManager': () => import(/* webpackChunkName: "czMessage" */'@/pages/caseMediate/czMessage'),
  'DownloadListManager': () => import(/* webpackChunkName: "downloadList" */'@/pages/sysTool/downloadList'),
  'LiveCaseManager': () => import(/* webpackChunkName: "liveCaseInfo" */'@/pages/caseMediate/liveCaseInfo'),
  'newCaseManager': () => import(/* webpackChunkName: "newCaseInfo" */'@/pages/caseMediate/newCaseInfo'),
  'FileManager': () => import(/* webpackChunkName: "FileInfo" */'@/pages/caseMediate/FileInfo'),
  'recycleBin': () => import(/* webpackChunkName: "FileInfo" */'@/pages/caseMediate/recycleBin'),
  'czSettlementData': () => import(/* webpackChunkName: "FileInfo" */'@/pages/caseMediate/czSettlementData'),
  'wyCaseManager': () => import(/* webpackChunkName: "FileInfo" */'@/pages/caseMediate/wyCaseInfo')
}
files.keys().forEach((key) => {
  if (key === './index.js') return
  Object.assign(componentMaps, files(key).default)
})
export default componentMaps
